import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const Popup = ({ confirmPopup, setConfirmPopup, Respone, page, type, getCallBack }) => {
    const [Error, setError] = useState([])
    const [errorData, setErrorData] = useState([])
    const handleClose = () => {
        setConfirmPopup(false)
        // if (type === "Lead" || type === "Contact" || type === "Deal" || type === "Account" || type === "Task") {
        getCallBack()
        // }
    }
    useEffect(() => {
        if (page === "Details") {
            const successData = Respone.filter(item => item.entityType === 'Success');
            const groupedData = successData.reduce((acc, item) => {
                const key = item.entityMessage || item.message;
                if (!acc[key]) acc[key] = [];
                acc[key].push(item.entityName);
                return acc;
            }, {});
            const sortedEntries = Object.entries(groupedData).sort(([a], [b]) => {
                if (a.includes("Updated Successfully")) return -1;
                if (b.includes("Updated Successfully")) return 1;
                return 0; // keep original order otherwise
            });
            setErrorData(sortedEntries)
            const nonSuccessData = Respone.filter(item => item.entityType !== 'Success');
            setError(nonSuccessData)
        }
        if (page === "DetailsError") {
            const successData = Respone.filter(item => item.entityType === 'Success');
            const groupedData = successData.reduce((acc, item) => {
                const key = item.entityMessage || item.message;
                if (!acc[key]) acc[key] = [];
                acc[key].push(item.entityName);
                return acc;
            }, {});
            const sortedEntries = Object.entries(groupedData).sort(([a], [b]) => {
                if (a.includes("Updated Successfully")) return -1;
                if (b.includes("Updated Successfully")) return 1;
                return 0; // keep original order otherwise
            });
            setErrorData(sortedEntries)
            const nonSuccessData = Respone.filter(item => item.entityType !== 'Success');
            const groupedArray = Object.values(
                nonSuccessData.reduce((acc, curr) => {
                    const { entityName, entity, entityData } = curr;

                    if (!acc[entityName]) {
                        acc[entityName] = {
                            entityName,
                            data: []
                        };
                    }

                    acc[entityName].data.push({ entity, entityData });

                    return acc;
                }, {})
            );
            setError(groupedArray)
        }
    }, [page, type])
    return (
        <>
            <Modal
                title="Linked records?"
                open={confirmPopup}
                onCancel={handleClose}
                maskClosable={false}
                footer={false}
            >
                <div  >
                    {page === "Details" ?
                        <>
                            {errorData.length > 0 && errorData.map(([message, names]) => (
                                <div key={message} style={{ marginBottom: 12 }}>
                                    <div style={{ marginBottom: 5, textAlign: "left" }}>{message?.includes("Updated Successfully") ? <CheckCircleOutlined style={{ color: "green" }} /> : <ExclamationCircleOutlined style={{ color: '#f28e42' }} />} {message?.includes("Updated Successfully") ? `Following ${type.toLowerCase()}s have been updated successful` : message}</div>
                                    <div style={{ paddingLeft: 20, wordBreak: 'break-word', textAlign: "left", fontWeight: 600 }}>
                                        {names.map((name, index) => (
                                            <span key={name}>
                                                {name}
                                                {index < names.length - 1 ? ', ' : ''}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                            {Error.length > 0 ? <>
                                <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15, marginBottom: 10 }}>
                                    <p><ExclamationCircleOutlined style={{ color: '#f28e42' }} /> This record cannot be updated because it has linked records. Please unassign or update those linked records before retrying.</p>
                                </div>
                                <div>
                                    {Error.map(item => {
                                        let displayValues = [];
                                        if (item.entity === 'Leads') {
                                            displayValues = item.entityData.map(lead => `${lead.firstName} ${lead.lastName}`);
                                        }
                                        else if (item.entity === 'Contacts') {
                                            displayValues = item.entityData.map(caseItem => `${caseItem.firstName} ${caseItem.lastName}`);
                                        }
                                        else if (item.entity === 'Accounts') {
                                            displayValues = item.entityData.map(caseItem => caseItem.accountName);
                                        }
                                        else if (item.entity === 'Deals') {
                                            displayValues = item.entityData.map(caseItem => caseItem.dealName);
                                        }
                                        else if (item.entity === 'Tasks') {
                                            displayValues = item.entityData.map(task => task.taskName);
                                        }
                                        else if (item.entity === 'Quotes') {
                                            displayValues = item.entityData.map(caseItem => caseItem.quotesName);
                                        }
                                        else if (item.entity === 'SalesOrders') {
                                            displayValues = item.entityData.map(caseItem => caseItem.salesOrderName);
                                        }
                                        else if (item.entity === 'Invoices') {
                                            displayValues = item.entityData.map(caseItem => caseItem.invoiceName);
                                        }
                                        else if (item.entity === 'Cases') {
                                            displayValues = item.entityData.map(caseItem => caseItem.caseSubject);
                                        }
                                        else if (item.entity === 'UserGroups') {
                                            displayValues = item.entityData.map(caseItem => caseItem.userGroupName);
                                        }
                                        else if (item.entity === 'Territories') {
                                            displayValues = item.entityData.map(caseItem => caseItem.territoryName);
                                        }
                                        else if (item.entity === 'ServiceLines') {
                                            displayValues = item.entityData.map(caseItem => caseItem.serviceLineName);
                                        }
                                        else if (item.entity === 'Campaign') {
                                            displayValues = item.entityData.map(caseItem => caseItem.campaignName);
                                        }
                                        return (
                                            <div key={item.entity}>
                                                Linked {item.entity} : <strong>{displayValues.join(', ')}</strong>
                                            </div>
                                        );
                                    })}
                                </div></> : <></>}
                        </>
                        :
                        page === "DetailsError" ?
                            <>
                                {errorData.length > 0 && errorData.map(([message, names]) => (
                                    <div key={message} style={{ marginBottom: 12 }}>
                                        <div style={{ marginBottom: 5, textAlign: "left" }}>{message?.includes("Updated Successfully")
                                            ? <CheckCircleOutlined style={{ color: "green" }} />
                                            : <ExclamationCircleOutlined style={{ color: '#f28e42' }} />} {message?.includes("Updated Successfully") ? `Following ${type.toLowerCase()}s have been updated successful` : message}</div>
                                        <div style={{ paddingLeft: 20, wordBreak: 'break-word', textAlign: "left", fontWeight: 600 }}>
                                            {names.map((name, index) => (
                                                <span key={name}>
                                                    {name}
                                                    {index < names.length - 1 ? ', ' : ''}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                                {Error.length > 0 ? <>
                                    <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15, marginBottom: 10 }}>
                                        <p><ExclamationCircleOutlined style={{ color: '#f28e42' }} /> Following record(s) cannot be updated because it has linked records. Please unassign or delete those linked records before retrying.</p>
                                    </div>
                                    <div>
                                        {Error.map((record, index) => (
                                            <div key={index} style={{ marginBottom: '5px' }}>
                                                Record Name : <strong>{record.entityName}</strong>
                                                <ul style={{ marginTop: '3px' }}>
                                                    {record.data.map((item, idx) => (
                                                        <li key={idx}>
                                                            Linked {item.entity} : <strong>{item.entityData.length}</strong>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div></> : <></>}
                            </> : ""
                    }
                </div>
            </Modal >
        </>
    );
};

Popup.propTypes = {
    confirmPopup: PropTypes.bool.isRequired,
    setConfirmPopup: PropTypes.func.isRequired,
    Respone: PropTypes.array.isRequired,
    page: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    getCallBack: PropTypes.func.isRequired,
};

export default Popup;